// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xv5H","colBig":"styles_colBig__1tGPV","colSmall":"styles_colSmall__1IBUi"};